import { render } from "./FilePlayer.vue?vue&type=template&id=3d6e3d2b&scoped=true"
import script from "./FilePlayer.vue?vue&type=script&lang=js"
export * from "./FilePlayer.vue?vue&type=script&lang=js"

import "./FilePlayer.vue?vue&type=style&index=0&id=3d6e3d2b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3d6e3d2b"

export default script